import { Box, Button, DialogBody, HStack, Separator, Spinner, Stack, Text } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"
import { UI } from "components"
import { API, toaster } from "config"
import useCart from "hooks/useCart"
import useSuppliers from "hooks/useSuppliers"
import { useState } from "react"

export default function ChangeSupplier({ ...props }) {

    const cart = useCart()
    const suppliers = useSuppliers()

    return (
        <UI.Dialog title="Alterar Filial de Compra" {...props}>
            <DialogBody>
                <Stack gap={4}>

                    <Text>
                        Você está comprando na filial <b>{cart.data?.distributor_from?.name}</b>.
                        Selecione abaixo de qual filial deseja comprar:
                    </Text>

                    <UI.Alert size="sm">
                        Ao alterar a filial, os itens do seu carrinho serão removidos e o timer será reiniciado.
                    </UI.Alert>

                    <Separator />

                    <UI.Show visible={suppliers.isFetching}>
                        <UI.Alert size="sm" indicator={<Spinner />}>Carregando fornecedores...</UI.Alert>
                    </UI.Show>

                    <Stack gap={2}>
                        {suppliers.data?.map(s => (
                            <SupplierRow
                                key={s.id}
                                data={s}
                                onClose={props?.onClose}
                            />
                        ))}
                    </Stack>

                    <Button size="sm" variant="ghost" onClick={() => props?.onClose()}>
                        <UI.Icon name="close" /> Fechar
                    </Button>

                </Stack>
            </DialogBody>
        </UI.Dialog>
    )
}

const SupplierRow = ({ data, onClose = () => {} }) => {

    const cart = useCart()
    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false)
    const isSelected = cart.data?.distributor_from?.id === data?.id

    const handleSelect = async () => {
        if (!window.confirm('Tem certeza que deseja alterar a filial? Seu carrinho será reiniciado.')) return
        setLoading(true)

        try {
            await API.put('/store/cart/supplier', { distributor_id: data?.id })
            // Fecha o dialog antes de invalidar para evitar removeChild durante animação de saída
            onClose()
            toaster.create({ title: 'Filial alterada com sucesso.', type: 'success' })
            queryClient.invalidateQueries({ queryKey: ['cart'] })
        } catch (err) {
            toaster.create({
                title: 'Não foi possível alterar a filial.',
                description: err?.response?.data?.message,
                type: 'warning',
            })
        }

        setLoading(false)
    }

    return (
        <Box
            borderWidth={1}
            borderRadius={6}
            borderColor={isSelected ? 'orange.400' : 'border'}
            p={3}
        >
            <HStack justify="space-between">
                <Box>
                    <Text fontWeight="bold">{data?.name}</Text>
                    <Text fontSize="xs" color="GrayText">
                        {data?.is_matriz ? 'Matriz' : 'Filial / CD'}
                    </Text>
                </Box>
                <Button
                    size="sm"
                    colorPalette="orange"
                    variant={isSelected ? 'outline' : 'solid'}
                    disabled={loading || isSelected}
                    loading={loading}
                    onClick={handleSelect}
                >
                    {isSelected ? 'Selecionado' : 'Selecionar'}
                </Button>
            </HStack>
        </Box>
    )
}
